module.exports = {
  sanity: {
    projectId: process.env.GATSBY_SANITY_PROJECT_ID || 'aykknk3u',
    dataset: process.env.GATSBY_SANITY_DATASET || 'staging'
  }
}
